import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import SVGImage from '~/components/Image/SVGImage'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { AppLanguage } from '~/types/locale'
import { MathEssentialProductAPIStat } from '~/redux/apis/user-stats-api'
import StripeProgressBar from '~/bootcamp/components/StripeProgressBar/StripeProgressBar'

import TimeStat from '../../ProfileCards/TimeStat'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  product: MathEssentialProductAPIStat
}

export default function Summary({ showContent, onClick, product }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(product.timeSpent)

  const { totalCorrectInBestAttempts, totalInCorrectInBestAttempts } = product.summary
  const toalAttempts = totalCorrectInBestAttempts + totalInCorrectInBestAttempts
  const totalAccuracy = toalAttempts > 0 ? Math.floor((totalCorrectInBestAttempts / toalAttempts) * 100) : 0

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: product.subject })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={product.subject}
        hrefLocale={product.supportsCurrentLocale ? undefined : AppLanguage.EN}
        iconAltText={t('alt_texts.math_essential')}
        iconSrcKey="icons/products/math-essentials.png"
        onClickTitle={onClickTitle}
        productHref={product.subjectPath}
        productSubtitle={t(`math-essentials-subjects.${product.subjectKey}`)}
        productTitle={t('math_essential')}
        showContent={showContent}
      />
      <div className="font-medium flex justify-between">
        <div className="flex items-center">
          <SVGImage alt={t('alt_texts.clock')} className="mr-2" height={20} srcKey="scoreboard/clock.svg" width={20} />
          <TimeStat days={days} hours={hours} minutes={minutes} />
        </div>
        <p>
          {t('correct-answer')} {totalAccuracy}%
        </p>
      </div>
      <StripeProgressBar percentage={product.summary.progressPercentage} />
    </button>
  )
}
